import Shape from "./Shape";

export default interface IDeal {
    id: number;
    status: DealStatus;
    value: number;
    labelId: number | null;
    name: string;
    dealStageId: number;

    contactPersonId: number | null;
    contactCompanyId: number | null;
    brokerId: number | null;
    propertyOwnerId: number | null;

    lat: number;
    lon: number;

    address: string | null;
    city: string | null;
    county: string | null;
    state: string | null;
    zoning: string | null;
    parcelId: string | null;
    regridId: string | null;
    buildingSize: number | null;
    landSizeAcres: number | null;
    usableLand: number | null;
    marketRentBuilding: number | null;
    marketRentLand: number | null;
    dealShapes: DealShape[];

    tenant: string | null;
    askingPrice: number | null;
    nonFund: string | null;
    dealProfile: string | null;
    sourcingMethod: string | null;

    dropboxLink: string | null;

    createdAt: Date;
    updatedAt: Date;

    assignedToUserId: number;

    OID: string | null;

    sold: string | null;

    lostReason: string | null;

    leaseCompIds: number[];
    saleCompIds: number[];
}

export interface IDealState {
    status: DealStatus | null;
    value: number | null;
    propertyOwnerName: string | null;
    name: string | null;
    contactPersonName: string | null;
    contactCompanyName: string | null;
    dealStageId: number | null;
    address: string | null;
    city: string | null;
    county: string | null;
    state: string | null;
    zoning: string | null;
    buildingSize: number | null;
    landSizeAcres: number | null;
    usableLand: number | null;
    dealShapeApns: (string | null)[];
    tenant: string | null;
    brokerName: string | null;
    askingPrice: number | null;
    nonFund: string | null;
    dealProfile: string | null;
    sourcingMethod: string | null;
    dropboxLink: string | null;
    assignedToUserId: number | null;
    OID: string | null;
    parcelId: string | null;
    regridId: string | null;
    labelId: number | null;
    lostReason: string | null;
    lostComment?: string | null;
    notes?: string | null;
    attachments?: File[];
}

export class DealState implements IDealState {
    status: DealStatus | null = null;
    value: number | null = null;
    propertyOwnerName: string | null = null;
    name: string | null = null;
    contactPersonName: string | null = null;
    contactCompanyName: string | null = null;
    dealStageId: number | null = null;
    address: string | null = null;
    city: string | null = null;
    county: string | null = null;
    state: string | null = null;
    zoning: string | null = null;
    buildingSize: number | null = null;
    landSizeAcres: number | null = null;
    usableLand: number | null = null;
    dealShapeApns: (string | null)[] = [];
    tenant: string | null = null;
    brokerName: string | null = null;
    askingPrice: number | null = null;
    nonFund: string | null = null;
    dealProfile: string | null = null;
    sourcingMethod: string | null = null;
    dropboxLink: string | null = null;
    assignedToUserId: number | null = null;
    OID: string | null = null;
    parcelId: string | null = null;
    regridId: string | null = null;
    labelId: number | null = null;
    lostReason: string | null = null;
    lostComment?: string | null = null;
    notes?: string | null = null;
    attachments?: File[] = [];

    static empty(): DealState {
        return new DealState();
    }
}

export enum DealStatus {
    Open = "open",
    Won = "won",
    Lost = "lost",
    Deleted = "deleted",
    AllNotDeleted = "all_not_deleted"
}

export class DealShape extends Shape {
    apn: string | null = null;
}